import React, { ReactElement } from 'react';

export const TextLink: React.FC<{ href: string }> = ({ href, children }): ReactElement => {
  return (
    <a href={href} className="is-link has-text-link">
      {children}
    </a>
  );
};
